import React from "react";
import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";

/**
 * Choose which of the center's certificate types a class or template issues. {@code available} is the center's
 * enabled types ({ type, name }); {@code value} the chosen type keys. Default is pre-chosen on new classes but can
 * be removed (an AHA-only class).
 */
export default function CertificateTypesPicker({ available = [], value = [], onChange, disabled = false, label = "Certificates issued", warnWhenEmpty = true }) {
  const toggle = (type, checked) => {
    const next = checked ? [...value, type] : value.filter((t) => t !== type);
    // Keep the center's order so the list reads the same everywhere.
    onChange(available.map((a) => a.type).filter((t) => next.includes(t)));
  };
  return (
    <Box data-testid="certificate-types-picker">
      <Typography component="div" sx={{ fontSize: 13, fontWeight: 700, mb: 0.5 }}>{label}</Typography>
      {available.length === 0 ? (
        <Typography variant="body2" color="text.secondary">No certificates are set up for this training center.</Typography>
      ) : (
        <FormGroup row>
          {available.map((a) => (
            <FormControlLabel key={a.type} label={a.name} disabled={disabled}
              control={<Checkbox size="small" checked={value.includes(a.type)} onChange={(e) => toggle(a.type, e.target.checked)} />} />
          ))}
        </FormGroup>
      )}
      {warnWhenEmpty && value.length === 0 && available.length > 0 && (
        <Typography variant="body2" color="warning.main">This class won't issue any certificate.</Typography>
      )}
    </Box>
  );
}
